import get from 'lodash/get';

export default state => {
  const shopsById = get(state, 'shops.shared.list.byId', {});
  return Object.values(shopsById);
};
